export default __webpack_public_path__ + "static/SharpGroteskBookItalic20-Regular-e23571ef94334db9dcfd56f497476918.woff";